<template>
  <b-autocomplete
    id="song-search"
    v-model="keyword"
    class="song-search"
    async
    icon="magnify"
    :data="data"
    field="label"
    placeholder="Search for a song in this timeline"
    :keep-first="true"
    size="is-small"
    :loading="isFetching"
    @input="getAsyncData"
    @select="select"
  >
    <template slot-scope="props">
      <p>
        <b>{{ props.option.label }}</b> 
        {{ props.option.year }} <br>
        <small
          v-if="props.option.author_id"
          class="mr-5"
        >
          <i class="mdi mdi-pencil" /> {{ $store.state.artists[props.option.author_id].label }}
        </small>
        <small
          v-if="props.option.interpret_id"
          class="mr-5"
        >
          <i class="mdi mdi-microphone" /> {{ $store.state.artists[props.option.interpret_id].label }}
        </small>
        <small
          v-if="props.option.composer_id"
          class="mr-5"
        >
          <i class="mdi mdi-pencil" /> {{ $store.state.artists[props.option.composer_id].label }}
        </small>
      </p>
    </template>

    <template slot="empty">
      No result
    </template>
  </b-autocomplete>
</template>

<script>

import debounce from "lodash/debounce";
import { searchFormat } from "@/services/helpers"; 

export default {
	props: {
		songs: {
			required: true,
			type: Array
		}
	},
	data () {
		return {
			keyword: "",
			isFetching: false,
			data: []
		};
	},
	methods: {
		getAsyncData: debounce(function() {
			this.isFetching = true;

			this.data = [];

			this.data = Object.values(this.songs).filter(song => {
				return searchFormat(song.label).indexOf(searchFormat(this.keyword)) >= 0;
			}).slice(0,30).sort((a,b) => {
				return (a.radius > b.radius);
			});

			this.isFetching = false;
		}, 500),
		select (value) {
			if (value == null) {
				this.$emit("select", null);
			} else {
				this.$emit("select", value);
			}
		}
	}
};
</script>

<style lang="scss">
.song-search {
  max-width: 500px;
  margin-bottom: 15px;
}
</style>